import { Link } from 'react-router-dom'
import { RegisterForm } from '../components/RegisterForm'

export const RegisterPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-4">
        <div className="flex justify-center">
          <img src="/vectorFP3Logo.svg" alt="FP3 Finance" className="h-24" />
        </div>
        <RegisterForm />
        <p
          className="text-center text-sm text-muted-foreground"
          data-testid="auth-register-login-prompt"
        >
          Already have an account?{' '}
          <Link
            to="/login"
            className="text-primary hover:underline font-medium"
            data-testid="auth-register-login-link"
          >
            Log in
          </Link>
        </p>
      </div>
    </div>
  )
}
